
































import { Vue, Component, Prop, Watch } from "division-marker";
import WtHttp from "@/components/WtHttp";

@Component({ components: {}, mixins: [] })
export default class StudentSignUp extends Vue {
  error: string | null = null;
  condition = { login_id: "", password: "", password2: "" };

  async onSubmit() {
    if (this.condition.password != this.condition.password2) {
      this.error = "パスワードとパスワード(確認)は同じ値を設定してください。";
      return;
    }
    try {
      const response = await WtHttp.post("./api/study/sign_up", {
        condition: this.condition
      });
      if (response.data.result == "ok") {
        let user = response.data.user;
        this.$store.commit("wt/user", user);
        window.location.href = "#/study/top";
      } else {
        this.error = `登録に失敗しました。${response.data.message}`;
      }
    } catch (error) {
      this.error = "登録エラーが発生しました。";
    }
  }
}
